<template>
  <v-flex
    v-if="decoder.screenshot"
    class="pa-2"
  >
    <div
      :class="{
        screenshotcontainer: $vuetify.breakpoint.mdAndUp,
        screenshotcontainersm: !$vuetify.breakpoint.mdAndUp,
      }"
      @click="screenshotPreviewOpen = true"
    >
      <img src="/static/touchterminal_display.png">
      <img
        class="screenshotimg"
        :src="decoder.screenshot"
      >
    </div>
    <v-dialog
      v-model="screenshotPreviewOpen"
      width="80vw"
    >
      <v-img
        :src="decoder.screenshot"
        @click="screenshotPreviewOpen = false"
      />
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  props: {
    decoder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      screenshotPreviewOpen: false,
    };
  },
};
</script>

<style scoped>
.screenshotcontainer {
  width: 800px;
  position: relative;
  cursor: pointer;
}

.screenshotcontainer > img {
  position: absolute;
  top: 0px;
  left: 0px;
  max-width: 100%;
}

.screenshotcontainer > .screenshotimg {
  position: absolute;
  width: 667px;
  left: 64px !important;
  margin-top: -31px;
  transform: perspective(1440px) rotateX(40deg);
  height: 357px;
}

.screenshotcontainersm {
  width: 364px;
  position: relative;
  cursor: pointer;
}

.screenshotcontainersm > img {
  position: absolute;
  top: 0px;
  left: 0px;
  max-width: 100%;
}

.screenshotcontainersm > .screenshotimg {
  position: absolute;
  width: 303px;
  left: 29px !important;
  margin-top: -14px;
  transform: perspective(655px) rotateX(40deg);
  height: 162px;
}
</style>



// WEBPACK FOOTER //
// src/components/DecoderDetail/TouchDecoderScreenshot.vue